export const environment = {
  apiBaseUrl:
    document.querySelector<HTMLMetaElement>('meta[name="vdocipher-api-base-url"]')?.content ||
    '/api',
};
